import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigTermsConditionsNoteComponent } from './uig-terms-conditions-note/uig-terms-conditions-note.component';
import {
  CmsConfig,
  ConfigModule,
  I18nModule,
  OccConfig, provideConfig,
  provideDefaultConfig,
  UrlModule
} from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { UigTermsConditionsDialogModule } from './uig-terms-conditions-dialog/uig-terms-conditions-dialog.module';
import { UigLegalAdapter } from './uig-legal.adapter';

@NgModule({
  declarations: [UigTermsConditionsNoteComponent],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    UigTermsConditionsDialogModule,
    ConfigModule.withConfig(<OccConfig> {
      backend: {
        occ: {
          endpoints: {
            termsAndConditionsAccept: '/users/${userId}/termsAndConditions/accept',
            termsAndConditionsDecline: '/users/${userId}/termsAndConditions/deny'
          }
        }
      }
    })
  ],
  providers: [
    {
      provide: UigLegalAdapter,
      useClass: UigLegalAdapter,
    },
    provideConfig(<CmsConfig>{
      cmsComponents: {
        TermsConditionsNoteComponent: {
          component: UigTermsConditionsNoteComponent
        }
      }
    })
  ],
  exports: [UigTermsConditionsNoteComponent],
})

export class UigLegalModule { }
